import {configureStore} from "@reduxjs/toolkit";
import {alertSlice} from "./slice/alertSlice";
import {languageSlice} from "./slice/languageSlice";
import {themeSlice} from "./slice/themeSlice";
import {seedSlice} from "./slice/seedSlice";

export const store = configureStore({
    reducer: {
        alert: alertSlice.reducer,
        language: languageSlice.reducer,
        seed: seedSlice.reducer,
        theme: themeSlice.reducer,
    }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
